/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Switch, withRouter } from "react-router-dom";
import List from "./List";
import POSEntry from "./POSEntry";
import { POSProvider } from "./POSContext";
import AppContext from "AppContext";
import PrivateRoute from "components/PrivateRoute";
import ReportsPage from "./Reports";

function POS() {
    const [isUserCreating, setIsUserCreating] = useState(false);
    const [documentIssuer, setDocumentIssuer] = useState(undefined);
    const {
        api: {
            POSEntries: { Master, Detail, Reports },
            Settings: { POSCategories, InvoicingIssuers },
        },
    } = useContext(AppContext);

    const getDocumentIssuer = async () => {
        try {
            return await InvoicingIssuers.getAsync();
        } catch {
            return null;
        }
    };

    useEffect(() => {
        const init = async () => {
            const dIssuer = await getDocumentIssuer();
            setDocumentIssuer(dIssuer);
        };
        init();

        return () => setDocumentIssuer(undefined);
    }, []);

    return (
        <POSProvider value={{ Master, Detail, Reports, POSCategories, isUserCreating, setIsUserCreating, documentIssuer }}>
            <Switch>
                <PrivateRoute exact path="/pos" component={List} />
                <PrivateRoute exact path="/pos/add" render={(props) => <POSEntry {...props} mode="add" title="Open Sell" />} />
                <PrivateRoute
                    exact
                    path="/pos/:id/update"
                    render={(props) => <POSEntry {...props} mode="update" title="Register Payments" />}
                />
                <PrivateRoute exact path="/pos/reports" component={ReportsPage} />
            </Switch>
        </POSProvider>
    );
}

export default withRouter(POS);
